import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "section-footer" }
const _hoisted_2 = { class: "content content-footer" }
const _hoisted_3 = { class: "footer-item middle" }
const _hoisted_4 = { class: "copyright" }
const _hoisted_5 = { class: "footer-item right" }
const _hoisted_6 = { class: "font-blackopsone" }
const _hoisted_7 = {
  target: "__blank",
  href: "https://etherscan.io/address/0x231e7ebe082dc9cb6c34c71e210d68a78e87a500#code"
}

import NavSocial from '@/components/NavSocial.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(NavSocial, { class: "footer-item left" }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('FOOTER_1')), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", _hoisted_6, [
          _createElementVNode("a", _hoisted_7, _toDisplayString(_ctx.$t('FOOTER_2')), 1)
        ])
      ])
    ])
  ]))
}
}

})